import React, { Suspense, lazy } from 'react';
import "./App.css";
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import Navbar from './components/Navbar';
import LandingNav from './components/LandingNav';
import Footer from './components/Footer/Footer';

// Route-level code splitting: each page loads its own chunk instead of one
// 1.8MB bundle. Keeps first paint fast for public pages like /posts.
const Dashboard = lazy(() => import('./dashboard/Dashboard'));
const Account = lazy(() => import('./account/Account'));
const Resources = lazy(() => import('./resources/Resources'));
const TeamSurvey = lazy(() => import('./survey/TeamSurvey'));
const MySurveys = lazy(() => import('./survey/MySurveys'));
const MyTeam = lazy(() => import('./team/MyTeam'));
const SurveyResult = lazy(() => import('./survey/SurveyResult'));
const TeamSurveyResults = lazy(() => import('./survey/TeamSurveyResults'));
const Tutorial = lazy(() => import('./tutorial/Tutorial'));
const Upgrade = lazy(() => import('./Upgrade/Upgrade'));
const Pricing = lazy(() => import('./pricing/Pricing'));
const PostFeed = lazy(() => import('./posts/PostFeed'));
const PostDetail = lazy(() => import('./posts/PostDetail'));
const CreatePost = lazy(() => import('./posts/CreatePost'));

const RouteFallback = () => (
  <div style={{ minHeight: '100vh', background: '#FDFAF4' }} />
);

// Blog pages share the static landing page's navigation; the rest of the
// app keeps its own Navbar.
const SiteNav = () => {
  const { pathname } = useLocation();
  return pathname.startsWith('/posts') ? <LandingNav /> : <Navbar />;
};

function App() {
  return (
    <div className="app" style={{background: '#31425b'}}>
      <Router>
      <SiteNav />
        <Suspense fallback={<RouteFallback />}>
          <Routes>
            <Route exact path="/" element={<Dashboard />} />
            <Route exact path="/dashboard" element={<Dashboard />} />
            <Route exact path="/resources" element={<Resources />} />
            <Route exact path="/account" element={<Account />} />
            <Route exact path="/survey" element={<TeamSurvey />} />
            <Route exact path="/my-team" element={<MyTeam />} />
            <Route exact path="/my-surveys" element={<MySurveys />} />
            <Route exact path="/survey-result" element={<SurveyResult />} />
            <Route exact path="/team-survey-result" element={<TeamSurveyResults />} />
            <Route exact path="/get-started" element={<Tutorial />} />
            <Route exact path="/upgrade" element={<Upgrade />} />
            <Route exact path="/pricing" element={<Pricing />} />
            <Route exact path="/posts" element={<PostFeed />} />
            <Route exact path="/posts/:postId" element={<PostDetail />} />
            <Route exact path="/create-new-post" element={<CreatePost />} />
          </Routes>
        </Suspense>
      </Router>
      <Footer/>
    </div>
  );
}
export default App;
